<div id="wwlink" class="view">
    <nav class="navbar fixed-top" id="mainnav">
        <div class="container-fluid">
            <a class="navbar-brand" routerLink="/">Dynalearn</a>
        </div>
    </nav>
    <div id="maincontent" class="container-fluid">
        @if (fout()) {
            <div class="alert alert-danger" role="alert">{{fout() | translate}}</div>
        }
        @if (succes()) {
            <div class="alert alert-success" role="alert">{{succes() | translate}}</div>
        }
        @if (fout() || succes()) {
            <div><a routerLink="/">{{'LOGIN.INLOGGEN' | translate}}</a></div>
        } @else {
            <form novalidate id="wijzigform" #wijzigform="ngForm">
                <h3>{{'WACHTWOORDVERGETEN.WIJZIG.TITLE' | translate}}</h3>
                <p>{{'WACHTWOORDVERGETEN.WIJZIG.UITLEG' | translate}}</p>
                <div class="mb-3">
                    <label for="nieuwwachtwoord">{{'WACHTWOORDVERGETEN.WIJZIG.LABEL' | translate}}</label>
                    <input id="nieuwwachtwoord" name="ww" type="password" minlength="6"
                           [(ngModel)]="formulier.ww" class="form-control"
                           autocomplete="off" required tabindex="1" autofocus>
                </div>
                <div class="mb-3">
                    <label for="nieuwwachtwoord2">{{'WACHTWOORDVERGETEN.WIJZIG.LABEL2' | translate}}</label>
                    <input id="nieuwwachtwoord2" name="ww2" type="password" minlength="6"
                           [(ngModel)]="formulier.ww2" class="form-control"
                           autocomplete="off" required tabindex="2">
                    @if (formulier.ww && formulier.ww.length && formulier.ww !== formulier.ww2) {
                        <p class="text-warning">{{'WACHTWOORDVERGETEN.WIJZIG.ONGELIJK' | translate}}</p>
                    }
                </div>
                <button type="button" class="btn btn-primary" [disabled]="!geldig()"
                        (click)="verstuurWachtwoord()">{{'WACHTWOORDVERGETEN.WIJZIG.BTN' | translate}}</button>
            </form>
        }
    </div>

    <footer id="mainfooter">
        <div class="container-fluid">
            <div class="row">
                <div class="footercol col-sm-6 text-start">
                    <span class="fa-solid fa-house"></span>&nbsp;&nbsp;DynaLearn Create v{{versie}}
                </div>
            </div>
        </div>
    </footer>
</div>
